import axios from 'axios';

export default function getListing({ activeOnly } = {}) {
  return new Promise((resolve, reject) => axios
    .get('/account/system-admin/api/v1/modules', {
      params: {
        active_only: activeOnly ? 1 : undefined,
      },
    })
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message)));
}
